<mat-expansion-panel [expanded]="filters.expanded.regulations" (opened)="opened()" (closed)="closed()">
    <mat-expansion-panel-header>
      <mat-panel-title>By Regulations</mat-panel-title>
    </mat-expansion-panel-header>

  <mat-checkbox color="primary" *ngFor="let regulation of defaults.regulations" (change)="toggle(regulation.record.id, $event.checked)" [checked]="filters.regulations.indexOf(regulation.record.id)!==-1" [disabled]="regulation.count === 0">{{ regulation.record.title }} ({{ regulation.count }})</mat-checkbox>
</mat-expansion-panel>
